import {
	ConfluencePageAri,
	JiraIssueAri,
	TownsquareGoalAri,
	TownsquareProjectAri,
	IdentityTeamAri,
} from '@atlassian/ari';
import type { GlobalObjectType } from '@atlassian/preview-panel-global-objects/types';

import { hasPreviewPanelIndicators, isInIframe } from './utils/previewPanelUtils.ts';

export const ALL_SUPPORTED_OBJECTS: GlobalObjectType[] = [
	'jira-issue',
	'confluence-page',
	'identity-team',
	'townsquare-goal',
	'townsquare-project',
];

export const isPreviewPanelAvailable = ({ ari }: { ari: string }): boolean => {
	const href = window?.location?.href;

	if (href) {
		const searchParams = new URL(href).searchParams;

		if (searchParams.get('parentProduct')?.toLowerCase() === 'jsm') {
			return false;
		}
		if (isInIframe() && !hasPreviewPanelIndicators(searchParams)) {
			return false;
		}
	}

	if (ConfluencePageAri.check(ari)) {
		return true;
	}
	if (JiraIssueAri.check(ari)) {
		return true;
	}
	if (TownsquareGoalAri.check(ari)) {
		return true;
	}
	if (TownsquareProjectAri.check(ari)) {
		return true;
	}
	if (IdentityTeamAri.check(ari)) {
		return true;
	}

	return false;
};
